import config from '@/config';

export function generateSwishUrl(swishToken: string, paymentId: string): string {
  const callbackUrl = `${config.app.paymentflow.callbackUrl}?paymentId=${paymentId}`;
  return `swish://paymentrequest?token=${swishToken}&callbackurl=${encodeURIComponent(callbackUrl)}`;
}
